/**
 * Beacon API Service Layer.
 *
 * Single source of truth for backend calls; each method is a thin
 * wrapper over fetchAsync that formats the URL and request body.
 */
import { fetchAsync } from '../utils/httpUtil';
import { FetchPaymentsResponse } from '../store/slices/payment/paymentState';
import { FetchExecutionsResponse } from '../store/slices/execution/executionState';
import { FetchFilesResponse } from '../store/slices/file/fileState';
import {
  GetExecutionsByStatusRequest,
  GetExecutionsByStatusResponse,
} from '../store/slices/executionsByStatus/executionsByStatusSlice';

export const beaconApi = {
  /** POST /payments/fetch — 1–100 payment IDs. */
  fetchPayments: (paymentIds: string[], apiBase: string): Promise<FetchPaymentsResponse> =>
    fetchAsync(`${apiBase}/payments/fetch`, 'POST', JSON.stringify({ paymentIds })),

  /** POST /executions/fetch — 1–100 execution IDs. */
  fetchExecutions: (executionIds: string[], apiBase: string): Promise<FetchExecutionsResponse> =>
    fetchAsync(`${apiBase}/executions/fetch`, 'POST', JSON.stringify({ executionIds })),

  /** POST /files/fetch — one page of executions matching 1–100 file names. */
  fetchFiles: (
    fileNames: string[],
    pageNumber: number,
    pageSize: number,
    apiBase: string,
  ): Promise<FetchFilesResponse> =>
    fetchAsync(`${apiBase}/files/fetch`, 'POST', JSON.stringify({ fileNames, pageNumber, pageSize })),

  /**
   * POST /executions/by-status — one page of executions matching a
   * status/state/dataSource + updatedAt range (plus optional
   * additionalFilters), paginated and sorted.
   */
  getExecutionsByStatus: (
    request: GetExecutionsByStatusRequest,
    apiBase: string,
  ): Promise<GetExecutionsByStatusResponse> =>
    fetchAsync(`${apiBase}/executions/by-status`, 'POST', JSON.stringify(request)),
};
